import { render, staticRenderFns } from "./AboutCardMkByAlfa.vue?vue&type=template&id=840b138c"
import script from "./AboutCardMkByAlfa.vue?vue&type=script&lang=js"
export * from "./AboutCardMkByAlfa.vue?vue&type=script&lang=js"
import style0 from "../about-card.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports